"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const ChevronUp = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M12.538 7.777a.75.75 0 0 0-1.076 0l-5.25 5.4a.75.75 0 0 0 1.076 1.046l4.702-4.858 4.722 4.858a.75.75 0 0 0 1.076-1.046l-5.25-5.4z", children: " " })
] });
var ChevronUp_default = ChevronUp;
export {
  ChevronUp_default as default
};
